var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectionImage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 25,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 26.0002C49.5 12 37 0.280165 23 2.00017",
    stroke: "#534B52",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.22 19.2C22.22 19.0667 22.2867 19 22.42 19H23.44C23.5733 19 23.64 19.0667 23.64 19.2V32.8C23.64 32.9333 23.5733 33 23.44 33H22.44C22.3467 33 22.2667 32.9533 22.2 32.86L15.38 21.76C15.3667 21.72 15.3467 21.7067 15.32 21.72C15.2933 21.72 15.28 21.74 15.28 21.78L15.3 32.8C15.3 32.9333 15.2333 33 15.1 33H14.08C13.9467 33 13.88 32.9333 13.88 32.8V19.2C13.88 19.0667 13.9467 19 14.08 19H15.08C15.1733 19 15.2533 19.0467 15.32 19.14L22.14 30.24C22.1533 30.28 22.1733 30.3 22.2 30.3C22.2267 30.2867 22.24 30.26 22.24 30.22L22.22 19.2ZM36.1822 20.04C36.1822 20.1733 36.1155 20.24 35.9822 20.24H28.6222C28.5689 20.24 28.5422 20.2667 28.5422 20.32V25.26C28.5422 25.3133 28.5689 25.34 28.6222 25.34H33.7822C33.9155 25.34 33.9822 25.4067 33.9822 25.54V26.38C33.9822 26.5133 33.9155 26.58 33.7822 26.58H28.6222C28.5689 26.58 28.5422 26.6067 28.5422 26.66V31.68C28.5422 31.7333 28.5689 31.76 28.6222 31.76H35.9822C36.1155 31.76 36.1822 31.8267 36.1822 31.96V32.8C36.1822 32.9333 36.1155 33 35.9822 33H27.3222C27.1889 33 27.1222 32.9333 27.1222 32.8V19.2C27.1222 19.0667 27.1889 19 27.3222 19H35.9822C36.1155 19 36.1822 19.0667 36.1822 19.2V20.04Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionImage1);
export default __webpack_public_path__ + "static/media/DirectionImage1.603ac5e9ac79f3b9d87148afd80c5292.svg";
export { ForwardRef as ReactComponent };